import { useListEvents } from "../hooks/useListEvents";
import type { Event } from "../types/event";
import EventItem from "./EventItem";
import EventsDateDivider from "./EventsDateDivider";
import SkeletonLoader from "./common/SkeletonLoader";

export const EventsListView = () => {
  const { isLoading, data } = useListEvents();

  if (isLoading) {
    return (
      <>
        <SkeletonLoader rows={1} height="52px" wrapperClassName="!px-0 mb-4" />
        <SkeletonLoader
          rows={1}
          height="20px"
          wrapperClassName="px-2 mb-4"
          width="25%"
        />
        <SkeletonLoader rows={4} height="70px" wrapperClassName="px-2 mb-4" />
        <SkeletonLoader
          rows={1}
          height="20px"
          wrapperClassName="px-2 mb-4"
          width="25%"
        />
        <SkeletonLoader rows={1} height="70px" wrapperClassName="px-2 mb-4" />
      </>
    );
  }

  const events = data?.records || [];

  return (
    <div className="hide-scrollbar bg-secondary flex h-full flex-col overflow-y-auto">
      {events.map((event: Event, index: number) => (
        <div key={event.id}>
          <EventsDateDivider
            current={event.starts_at}
            previous={events[index - 1]?.starts_at}
          />
          <div className="px-4">
            <EventItem key={event.id} event={event} showArrowIcon={false} />
          </div>
        </div>
      ))}
    </div>
  );
};
